import script from "./MonitorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitorPage.vue?vue&type=script&setup=true&lang=js"

import "./MonitorPage.vue?vue&type=style&index=0&id=9cf99010&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cf99010"]])

export default __exports__